"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APTable = _interopRequireDefault(require("../../../common/APTable"));
var _ActivityCellComponents = require("../ActivityCellComponents");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var InterestPaymentsTable = function InterestPaymentsTable(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('interest'),
    t = _useTranslation.t;
  var usePagination = props.usePagination,
    interestPayments = props.interestPayments;
  var columns = [{
    header: t('Product'),
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Action, {
        value: row,
        showProductIcon: true,
        themeModifier: props.themeModifier
      });
    }
  }, {
    header: t('Date'),
    width: '15rem',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.DateTime, {
        value: row.TimeStamp
      });
    }
  }, {
    header: t('Payout Quantity'),
    width: '20rem',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Amount, {
        value: row
      });
    }
  }, {
    header: t('Transaction ID'),
    width: '40rem',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_ActivityCellComponents.Status, {
        value: row
      });
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    componentName: 'InterestPaymentsTable',
    columns: columns,
    pageSize: 6,
    minRow: 6,
    rows: interestPayments,
    baseClass: baseClasses,
    headerOutside: true,
    usePagination: usePagination,
    empty: t('No data is available')
  });
};
InterestPaymentsTable.defaultProps = {
  usePagination: false
};
var _default = exports["default"] = InterestPaymentsTable;